import store from './storage';
import { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { MockFn, MockRequest } from './types';
import { parseJwt } from './utils';

class Config {
  private static instance: Config;

  public getTokenKey: (url?: string) => string;
  public baseURL: string;
  private mockAdapter: MockAdapter | undefined;
  private handlers: {
    [name: string]: MockRequest;
  };

  private constructor() {
    this.getTokenKey = () => {
      return 'access_token';
    };
    this.handlers = {};
    this.baseURL = process.env.REACT_APP_API_URL || '/';
  }

  public static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config();
    }

    return Config.instance;
  }

  isRemember(): boolean {
    return store.isRemember();
  }

  setRemember(value: boolean) {
    store.setRemember(value);
  }

  addMockRequests(requests: MockRequest[]) {
    const handlers: { [name: string]: any } = {};
    requests.forEach((request) => {
      if (request.url && request.method) {
        handlers[request.name] = request;
      }
    });

    this.handlers = { ...this.handlers, ...handlers };
    const callback = (config: any, mockData: MockFn) => {
      const response = mockData(config);
      if (response instanceof Array) {
        return response;
      }
      return [200, response];
    };
    Object.values(handlers).forEach((request) => {
      const { method, url, mockData } = request;
      if (method === 'GET') {
        this.mockAdapter
          ?.onGet(url)
          .reply((config) => callback(config, mockData));
      } else if (method === 'POST') {
        this.mockAdapter
          ?.onPost(url)
          .reply((config) => callback(config, mockData));
      } else if (method === 'PUT') {
        this.mockAdapter
          ?.onPut(url)
          .reply((config) => callback(config, mockData));
      }
    });
  }

  setupMock(axiosInstance: AxiosInstance) {
    this.mockAdapter = new MockAdapter(axiosInstance, {
      onNoMatch: 'passthrough',
    });
  }

  getApitHandlers() {
    return Object.values(this.handlers);
  }

  getTokenValue(url?: string): Record<string, any> | undefined {
    const accessKey = this.getTokenKey(url);
    const token = store.getItem(accessKey);
    if (token) {
      try {
        return parseJwt(token);
      } catch (_error) {
        this.removeSession();
      }
    }
    return undefined;
  }

  removeSession(url?: string) {
    store.removeItem(this.getTokenKey(url));
    store.clear();
    localStorage.clear();
  }
}

export default Config;
